import { render, staticRenderFns } from "./changeMoneyDialog.vue?vue&type=template&id=1ddb5d7c&"
import script from "./changeMoneyDialog.vue?vue&type=script&lang=js&"
export * from "./changeMoneyDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports